import React from 'react';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import getFonts from '../../../Functions/config/fonts';
import getSelectField from '../../fields/select';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

const ButtonSettings = ({ widget, handleInputChange, setColorsAndPreview }) => {
    const { affordability } = widget.htmlData;
    const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));

    const renderButtonConfig = (buttonType, title) => (
        <AccordionItem className="mjwi-sub-accordion" key={buttonType}>
            <AccordionItemHeading>
                <AccordionItemButton>{title}</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
                <div className="mjwi-acc-panel-wrapper">
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <label>Text</label>
                        </div>
                        <div className="mjwi-col50">
                            <input
                                type="text"
                                name="text"
                                value={affordability.button[buttonType].text}
                                onChange={(e) => handleInputChange(e, ['button', buttonType])}
                                className="mjwi-input"
                            />
                        </div>
                    </div>
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <label>Text Color</label>
                        </div>
                        <div className="mjwi-col66 mjwi-clr-picker">
                            <span
                                className="clrPickerVal"
                                style={{ backgroundColor: affordability.button[buttonType].textColor }}
                                onClick={toggleColorPicker}
                            ></span>
                            <HexAlphaColorPicker
                                color={affordability.button[buttonType].textColor}
                                onChange={(color) => setColorsAndPreview(`button.${buttonType}`, 'textColor', color)}
                                style={{ display: 'none' }}
                                className="mjwi-apfl-color-picker"
                            />
                            <HexColorInput
                                color={affordability.button[buttonType].textColor}
                                onChange={(color) => setColorsAndPreview(`button.${buttonType}`, 'textColor', color)}
                            />
                        </div>
                    </div>
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <label>Background Color</label>
                        </div>
                        <div className="mjwi-col66 mjwi-clr-picker">
                            <span
                                className="clrPickerVal"
                                style={{ backgroundColor: affordability.button[buttonType].bgColor }}
                                onClick={toggleColorPicker}
                            ></span>
                            <HexAlphaColorPicker
                                color={affordability.button[buttonType].bgColor}
                                onChange={(color) => setColorsAndPreview(`button.${buttonType}`, 'bgColor', color)}
                                style={{ display: 'none' }}
                                className="mjwi-apfl-color-picker"
                            />
                            <HexColorInput
                                color={affordability.button[buttonType].bgColor}
                                onChange={(color) => setColorsAndPreview(`button.${buttonType}`, 'bgColor', color)}
                            />
                        </div>
                    </div>
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <label>Hover Color</label>
                        </div>
                        <div className="mjwi-col66 mjwi-clr-picker">
                            <span
                                className="clrPickerVal"
                                style={{ backgroundColor: affordability.button[buttonType].hoverColor }}
                                onClick={toggleColorPicker}
                            ></span>
                            <HexAlphaColorPicker
                                color={affordability.button[buttonType].hoverColor}
                                onChange={(color) => setColorsAndPreview(`button.${buttonType}`, 'hoverColor', color)}
                                style={{ display: 'none' }}
                                className="mjwi-apfl-color-picker"
                            />
                            <HexColorInput
                                color={affordability.button[buttonType].hoverColor}
                                onChange={(color) => setColorsAndPreview(`button.${buttonType}`, 'hoverColor', color)}
                            />
                        </div>
                    </div>
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <label>Font Weight</label>
                        </div>
                        <div className="mjwi-col50">
                            {getSelectField('fontWeight', ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'], affordability.button[buttonType].fontWeight, (e) => handleInputChange(e, ['button', buttonType]))}
                        </div>
                    </div>
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <label>Border Radius</label>
                        </div>
                        <div className="mjwi-col50">
                            <div className="mjwi-size-input">
                                <input
                                    type="number"
                                    name="borderRadius"
                                    value={parseFloat(affordability.button[buttonType].borderRadius) || ''}
                                    onChange={(e) => handleInputChange({ target: { name: 'borderRadius', value: `${e.target.value}px` } }, ['button', buttonType])}
                                    className="mjwi-input"
                                    min="0"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <label>Font Size</label>
                        </div>
                        <div className="mjwi-col50">
                            <div className="mjwi-size-input">
                                <input
                                    type="number"
                                    name="fontSize"
                                    value={parseFloat(affordability.button[buttonType].fontSize) || ''}
                                    onChange={(e) => handleInputChange({ target: { name: 'fontSize', value: `${e.target.value}px` } }, ['button', buttonType])}
                                    className="mjwi-input"
                                    min="0"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <label>Font Family</label>
                        </div>
                        <div className="mjwi-col50">
                            {getSelectField('fontFamily', fontFamilyOptions.map(opt => opt.label), affordability.button[buttonType].fontFamily || 'Arial, sans-serif', (e) => handleInputChange(e, ['button', buttonType]))}
                        </div>
                    </div>
                </div>
            </AccordionItemPanel>
        </AccordionItem>
    );

    return (
        <div className="mjwi-acc-panel-wrapper">
            <Accordion allowZeroExpanded>
                {renderButtonConfig('calculate', 'Calculate Button')}
                {renderButtonConfig('reset', 'Reset Button')}
            </Accordion>
        </div>
    );
};

export default ButtonSettings;